/*
  The session provider checks all failed http requests. It emits an error that
  is picked up by index.run.js.
*/
export default class SessionProvider {
  $get($q, $rootScope, appModel) {
    "ngInject";
    return {
	  get(config) {
        if (appModel.authString) {
          const authString = appModel.authString;
          config.withCredentials = true;
          config.headers = {
            Authorization: `Basic ${authString}`
          };
        }
        return config;
      },    
      request(config) {
        if (appModel.authString) {
          const authString = appModel.authString;
          config.withCredentials = true;
          config.headers = {
            Authorization: `Basic ${authString}`
          };
        }
        return config;
      },
      response(response) {
        $rootScope.$emit('http-response', response);

        /* Fetch the system request. */
        const systemRequests = response.data.systemRequests;
        //const systemRequest = 'debugOn';
        if (systemRequests) {
          $rootScope.$emit('systemRequests', systemRequests);
        }
        return response.data;
      },
      responseError(response) {
        $rootScope.$emit('http-response-error', response);

        /* Emit the error for generic error handling. */
        let errorMessage;
        try {
          if (_.isString(response)) {
            errorMessage = response;
          } else {
            errorMessage = response.data.result || 'Unknown server error';
          }
        } catch (error) {
          errorMessage = 'Unknown server error';
        }
        const code = `http-code-${response.status}`;
        $rootScope.$emit(code, errorMessage);
        return $q.reject(response);
      }
    };
  }
}



// WEBPACK FOOTER //
// ./client/app/session.provider.js